import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { withRouter } from "react-router-dom";
import { Button } from "reactstrap";
import s from "./styles.scss";
import jsPDF from "jspdf";
import { errorNotification } from "../../../../utils/notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCamera,
  faFileImage,
  faPlus,
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import { errorOBNotification } from "../../../../OnBoardingUI/components/OBNotification/OBNotification.utils";

interface Props {
  minPhotos: number;
  exportButtonTitle: string;
  exportFile: (pdf: File) => any;
}

interface State {
  photos: any[];
  photoIndex: number;
  photo: any;
  started: boolean;
  wait: boolean;
}

class CamMultiCapture extends React.Component<Props, State> {
  state = {
    photos: [],
    photoIndex: -1,
    photo: null,
    started: false,
    wait: false
  };

  exportToPdf = async () => {
    const { photos } = this.state;
    const minPhotos = this.props.minPhotos || 1;
    if (photos.length < minPhotos) {
      errorNotification(
        `Debe capturar al menos ${minPhotos} foto(s) del documento`
      );
      return;
    }

    const pdf = new jsPDF();

    const padding = 10;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const availableHeight = pageHeight - 2 * padding;

    let totalOriginalHeight = 0;
    let scaledImages: { width: number; height: number; dataURL: string }[] = [];

    photos.forEach(dataURL => {
      const imgProps = pdf.getImageProperties(dataURL);
      const imgWidth = pageWidth - 2 * padding;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
      totalOriginalHeight += imgHeight;
      scaledImages.push({ width: imgWidth, height: imgHeight, dataURL });
    });

    if (photos.length === 1) {
      const img = scaledImages[0];
      const imgProps = pdf.getImageProperties(img.dataURL);

      const scaleX = (pageWidth - 2 * padding) / imgProps.width;
      const scaleY = (pageHeight - 2 * padding) / imgProps.height;
      const scale = Math.min(scaleX, scaleY);

      const scaledWidth = imgProps.width * scale;
      const scaledHeight = imgProps.height * scale;
      const xPosition = (pageWidth - scaledWidth) / 2;
      const yPosition = (pageHeight - scaledHeight) / 2;

      pdf.addImage(
        img.dataURL,
        "PNG",
        xPosition,
        yPosition,
        scaledWidth,
        scaledHeight
      );
    } else {
      const scaleFactor = availableHeight / totalOriginalHeight;
      let yPosition = padding;

      scaledImages.forEach(img => {
        const scaledWidth = img.width * scaleFactor;
        const scaledHeight = img.height * scaleFactor;
        pdf.addImage(
          img.dataURL,
          "PNG",
          padding,
          yPosition,
          scaledWidth,
          scaledHeight
        );
        yPosition += scaledHeight;
      });
    }

    const pdfBlob = pdf.output("blob");
    var file = new File([pdfBlob], "documento.pdf", {
      type: "application/pdf"
    });
    //var fileURL = URL.createObjectURL(file);
    //window.open(fileURL);
    if (!!this.props.exportFile) {
      this.props.exportFile(file);
    }
  };

  openToPdf = () => {
    const { photos } = this.state;
    const minPhotos = this.props.minPhotos || 1;
    if (photos.length < minPhotos) {
      errorNotification(
        `Debe capturar al menos ${minPhotos} foto(s) del documento`
      );
      return;
    }

    const pdf = new jsPDF();

    const padding = 10;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const availableHeight = pageHeight - 2 * padding;

    let totalOriginalHeight = 0;
    let scaledImages: { width: number; height: number; dataURL: string }[] = [];

    photos.forEach(dataURL => {
      const imgProps = pdf.getImageProperties(dataURL);
      const imgWidth = pageWidth - 2 * padding;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
      totalOriginalHeight += imgHeight;
      scaledImages.push({ width: imgWidth, height: imgHeight, dataURL });
    });

    if (photos.length === 1) {
      const img = scaledImages[0];
      const imgProps = pdf.getImageProperties(img.dataURL);

      const scaleX = (pageWidth - 2 * padding) / imgProps.width;
      const scaleY = (pageHeight - 2 * padding) / imgProps.height;
      const scale = Math.min(scaleX, scaleY);

      const scaledWidth = imgProps.width * scale;
      const scaledHeight = imgProps.height * scale;
      const xPosition = (pageWidth - scaledWidth) / 2;
      const yPosition = (pageHeight - scaledHeight) / 2;

      pdf.addImage(
        img.dataURL,
        "PNG",
        xPosition,
        yPosition,
        scaledWidth,
        scaledHeight
      );
    } else {
      const scaleFactor = availableHeight / totalOriginalHeight;
      let yPosition = padding;

      scaledImages.forEach(img => {
        const scaledWidth = img.width * scaleFactor;
        const scaledHeight = img.height * scaleFactor;
        pdf.addImage(
          img.dataURL,
          "PNG",
          padding,
          yPosition,
          scaledWidth,
          scaledHeight
        );
        yPosition += scaledHeight;
      });
    }

    const pdfBlob = pdf.output("blob");
    var file = new File([pdfBlob], "documento.pdf", {
      type: "application/pdf"
    });
    var fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  };

  render() {
    return (
      <div className="mb-5">
        {/* Captura de fotos */}
        <div
          style={{
            padding: "8px",
            background: "#ddd",
            fontSize: "13px",
            marginBottom: "16px"
          }}
        >
          Capture las fotos del documento, pueden ser hasta dos.
        </div>

        <div>
          {/* Vista previa */}
          <div className={s.photoContainer}>
            {/* Imagen seleccionada */}
            <div hidden={!this.state.started} className={s.photoData}>
              {this.state.photo == null ? (
                <FontAwesomeIcon icon={faFileImage} />
              ) : (
                <img src={this.state.photo} />
              )}

              {/* Botón de eliminación */}
              <div
                className={s.photoDelete}
                hidden={this.state.photo == null}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();

                  // Se elimina la foto visualizada
                  const index = this.state.photoIndex;
                  const photos = [...this.state.photos];
                  photos.splice(index, 1);
                  this.setState({
                    photos,
                    photoIndex: -1,
                    photo: null
                  });
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </div>
            </div>
          </div>

          {/* Carrusel de imágenes cargadas */}
          <div className={s.photoOptionsContainer}>
            <div className={s.photoOptionsCarousel}>
              {/* Botón para agregar archivo */}
              <div className={`${s.photoThumb} ${s.photoThumbButton}`}>
                <FontAwesomeIcon icon={faPlus} />
                <input
                  className={s.inputFile}
                  type="file"
                  accept="image/*"
                  capture="environment"
                  id="cameraInput"
                  onChange={evt => {
                    const file =
                      evt.target.files &&
                      evt.target.files.length > 0 &&
                      evt.target.files[0];

                    if (!file) {
                      return;
                    }

                    if (!file.type.startsWith("image/")) {
                      errorOBNotification(
                        "El archivo seleccionado no es una imagen."
                      );
                      return;
                    }

                    const oldPhotos = this.state.photos || [];
                    const index = oldPhotos.length;
                    const photo = URL.createObjectURL(file);
                    this.setState({
                      photos: [...oldPhotos, photo],
                      photoIndex: index,
                      photo,
                      started: true
                    });
                  }}
                />
              </div>

              {/* Ficticia, si falta  */}
              <div
                hidden={this.state.photos && this.state.photos.length > 0}
                className={`${s.photoThumbEmpty}`}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.setState({
                    photoIndex: -1,
                    photo: null
                  });
                }}
              ></div>

              {/* Miniaturas */}
              {(this.state.photos || []).map((uri, index) => {
                return (
                  <div
                    key={"phcp-" + index}
                    className={`${s.photoThumb} ${
                      this.state.photoIndex === index ? s.photoThumbActive : ""
                    }`}
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.setState({
                        photoIndex: index,
                        photo: uri
                      });
                    }}
                  >
                    <img src={uri} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Botón de carga de imagen */}
        <div className="mt-3 mb-3">
          <Button
            className={`${s.primaryOBButton} mt-3`}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();

              this.setState({
                wait: true
              });

              this.exportToPdf()
                .then(() => {
                  this.setState({
                    wait: false
                  });
                })
                .catch(err => {
                  this.setState({
                    wait: false
                  });

                  errorOBNotification("Error al exportar el documento.");
                });
            }}
            block
            disabled={
              !this.state.photos ||
              this.state.photos.length > 2 ||
              this.state.photos.length == 0 ||
              this.state.wait
            }
            hidden={!this.state.photos || this.state.photos.length == 0}
          >
            {!this.state.photos || this.state.photos.length == 0
              ? "Captura una foto"
              : ""}
            {this.state.photos && this.state.photos.length > 2
              ? "Dos fotos máximo"
              : ""}
            {this.state.photos &&
            (this.state.photos.length === 1 || this.state.photos.length === 2)
              ? "Guardar documento"
              : ""}
          </Button>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(s)(CamMultiCapture));
